import script from "./audio.vue?vue&type=script&setup=true&lang=ts"
export * from "./audio.vue?vue&type=script&setup=true&lang=ts"

import "./audio.vue?vue&type=style&index=0&id=1b252556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b252556"]])

export default __exports__